import { render, staticRenderFns } from "./PgaPage.vue?vue&type=template&id=89a04c08&"
import script from "./PgaPage.vue?vue&type=script&lang=ts&"
export * from "./PgaPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89a04c08')) {
      api.createRecord('89a04c08', component.options)
    } else {
      api.reload('89a04c08', component.options)
    }
    module.hot.accept("./PgaPage.vue?vue&type=template&id=89a04c08&", function () {
      api.rerender('89a04c08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Shared/Layout/PgaPage.vue"
export default component.exports